import React from 'react';
import {Link} from "react-router-dom";

function Menu() {

    return (
        <>
            <Link
                to="/intro"
                className="slick-arrow slick-prev"
            >
                <svg className="ontario-icon" aria-hidden="true" focusable="false"
                     viewBox="0 0 24 24" preserveAspectRatio="xMidYMid meet">
                    <path d="M15.4 7.4L14 6l-6 6 6 6 1.4-1.4-4.58-4.6 4.58-4.6z" fill=""/>
                </svg>
            </Link>

            <Link to="/tabs" className="slick-arrow slick-next">
                <svg className="ontario-icon" aria-hidden="true" focusable="false"
                     viewBox="0 0 24 24" preserveAspectRatio="xMidYMid meet">
                    <path d="M10 6L8.6 7.4l4.58 4.6-4.58 4.6L10 18l6-6-6-6z" fill=""/>
                </svg>
            </Link>

            <main id="content" role="main">
                <div className="ontario-row">
                    <div
                        className="ontario-column ontario-small-push-2 ontario-small-8 ontario-margin-top-24-! ontario-margin-bottom-16-!">

                        <h1>Off Canvas Menu</h1>
                        <p>A common interface pattern for navigation on narrow viewports, the off-canvas menu
                            component consists of
                            a hidden panel and a button to toggle its visibility.</p>
                    </div>
                </div>
                <section>
                    <div className="ontario-row">
                        <div
                            className="ontario-column ontario-small-push-2 ontario-small-8 ontario-margin-top-24-! ontario-margin-bottom-16-!">

                            <header className="content-header">

                                <h1 className="text-large">
                                    Accesiblity
                                </h1>

                            </header>

                            <p><code>aria-controls</code> is used to associate the button with its
                                panel and <code>aria-hidden</code> is toggled when the panel is
                                opened or closed, this preserves consistency between the DOM and the accessibility tree.
                            </p>
                            <p>To retain the correct taborder, focus is applied to the panel when opening and returned
                                to the
                                button when closed.</p>
                            <p>A few handy extra events are bound, keyboard navigation is enabled with the <code
                            >ESC</code> key closing the panel and any interactions outside of the
                                panel similarly closing it.</p>
                            <p>It’s important to note that no assumption is made about the panel containing navigation,
                                hence the
                                lack of a <code>role="navigation"</code>; the component is simply
                                defined as a collapsible section of the document. Navigation can of course be contained
                                within the
                                panel, in which case it’s recommended to use a <code
                                >&lt;nav&gt;</code> element for correct interpretation by the
                                browser.</p>

                            <h2 className="visually-hidden">
                                View sources
                            </h2>

                            <a className="ontario-button ontario-button--secondary"
                               href="#">
                                HTML
                            </a>

                            <a className="ontario-button ontario-button--secondary"
                               href="#">
                                CSS
                            </a>

                            <a className="ontario-button ontario-button--secondary"
                               href="#">
                                JS
                            </a>


                            <h2 id="install">Install</h2>
                            <p>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Integer enim mauris,
                                sollicitudin condimentum eleifend eu, pellentesque sed turpis. Sed dictum, felis in
                                ultricies mattis, elit magna dictum felis, quis pharetra ex elit eget lectus. Sed
                                vestibulum lectus sit amet neque finibus, ut finibus massa vestibulum. </p>


                        </div>
                    </div>
                </section>
            </main>

        </>
    );
}

export default Menu;